// https://manage.zilochat.com
// http://localhost:8080/zilochat-crm/public
const BASE_URL = 'https://manage.zilochat.com';
export default BASE_URL;